(function () {
  // 1) Détecter la langue (Shopify + fallback html lang)
  function getLocale() {
    const l =
      (window.Shopify && (Shopify.locale || Shopify.language)) ||
      document.documentElement.lang ||
      "fr";
    const v = (l || "").toLowerCase();
    return v.startsWith("fr") ? "fr" : "en";
  }

  // 2) Textes + heuristiques par langue
  const COPY = {
    fr: {
      label: "En savoir plus sur l'abonnement",
      popupNeedle: (t) => t.includes("en savoir plus") && t.includes("abonn"),
    },
    en: {
      label: "Learn more about the subscription",
      popupNeedle: (t) => t.includes("learn more") && (t.includes("subscr") || t.includes("subscription")),
    },
  };

  const norm = (s) =>
    (s || "")
      .replace(/\u00A0/g, " ")
      .replace(/[’‘]/g, "'")
      .toLowerCase()
      .replace(/\s+/g, " ")
      .trim();

  function findLoopRoot() {
    return (
      document.querySelector(".loop-widget-container") ||
      document.querySelector("[class*='loop-widget']") ||
      null
    );
  }

  function findSubscriptionContainer(loopRoot) {
    const opts = loopRoot.querySelectorAll(".loop-widget-purchase-option");
    if (opts && opts.length >= 2) return opts[1]; // 2e option = abonnement
    return loopRoot;
  }

  // 3) Trouver une ligne "proche" de l’explication abonnement (FR/EN)
  function findTargetLine(subContainer) {
    const nodes = subContainer.querySelectorAll("span, p, div");
    for (const el of nodes) {
      const t = norm(el.textContent);
      if (!t) continue;

      // FR/EN mots-clés (plus tolérant)
      const hasCancel =
        t.includes("annule") || t.includes("annuler") || t.includes("cancel") || t.includes("cancelle");

      const hasSkipOrPause =
        t.includes("saute") || t.includes("sauter") || t.includes("skip") || t.includes("pause");

      const hasModify =
        t.includes("modifier") || t.includes("ajuster") || t.includes("modify") || t.includes("edit") || t.includes("change");

      const hasAnytime =
        t.includes("tout temps") || t.includes("n'importe quand") || t.includes("anytime");

      // Heuristique: si on voit cancel + (skip/pause/modify) ou cancel + anytime, c’est probablement la ligne
      if (hasCancel && (hasSkipOrPause || hasModify || hasAnytime)) return el;
    }

    // Fallback: si Loop change le texte, on injecte quand même à la fin du bloc abonnement
    // (dernier élément "texte" trouvé)
    return nodes.length ? nodes[nodes.length - 1] : null;
  }

  // 4) Trouver le bouton pop-up original du thème (sans dépendre d’un seul libellé)
  function findOriginalPopupButton(loopRoot) {
    const loc = getLocale();
    const isNeedle = COPY[loc].popupNeedle;

    // Priorité: triggers pop-up du thème
    const candidates = Array.from(
      document.querySelectorAll(
        "button.product-popup, a.product-popup, button[aria-controls*='Popup'], a[aria-controls*='Popup'], a[href^='#Popup'], button[data-modal], a[data-modal]"
      )
    );

    // 1) Si on trouve un candidat dont le texte matche la langue courante → parfait
    let hit = candidates.find((el) => isNeedle(norm(el.textContent)));
    if (hit) return hit;

    // 2) Sinon, essayer l’autre langue (utile si le thème garde un libellé unique)
    const other = loc === "fr" ? "en" : "fr";
    hit = candidates.find((el) => COPY[other].popupNeedle(norm(el.textContent)));
    if (hit) return hit;

    // 3) Sinon, si un seul pop-up existe sur la page produit, on le prend
    if (candidates.length === 1) return candidates[0];

    // 4) Dernier fallback: chercher n’importe quel bouton/lien qui ressemble
    const all = Array.from(document.querySelectorAll("button, a"));
    hit = all.find((el) => {
      const t = norm(el.textContent);
      return (
        COPY.fr.popupNeedle(t) ||
        COPY.en.popupNeedle(t)
      );
    });

    return hit || null;
  }

  function ensureRow(afterEl) {
    const next = afterEl.nextElementSibling;
    if (next && next.classList.contains("subscription-learnmore-row")) return next;

    const row = document.createElement("div");
    row.className = "subscription-learnmore-row";
    afterEl.insertAdjacentElement("afterend", row);
    return row;
  }

  function ensureLink(row, loopRoot) {
    const loc = getLocale();

    let btn = row.querySelector(".subscription-learnmore-btn");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "subscription-learnmore-btn";

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const original = findOriginalPopupButton(loopRoot);
        if (original) original.click();
      });

      row.appendChild(btn);
    }

    // IMPORTANT: mettre à jour le texte à chaque render (si l’utilisateur change de langue)
    btn.textContent = COPY[loc].label;

    return btn;
  }

  // Rend l’injection idempotente
  function render() {
    const loopRoot = findLoopRoot();
    if (!loopRoot) return false;

    const sub = findSubscriptionContainer(loopRoot);
    const target = findTargetLine(sub);
    if (!target) return false;

    const row = ensureRow(target);
    ensureLink(row, loopRoot);

    return true;
  }

  let raf = null;
  function scheduleRender() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      render();
    });
  }

  function boot() {
    render();

    const obs = new MutationObserver(() => scheduleRender());
    obs.observe(document.documentElement, { childList: true, subtree: true });

    const start = Date.now();
    const timer = setInterval(() => {
      render();
      if (Date.now() - start > 5000) clearInterval(timer);
    }, 250);
  }

  document.addEventListener("DOMContentLoaded", boot);
})();
